import React from 'react';
import { AdminLayout } from '../../components/layouts/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Search, MoreHorizontal } from 'lucide-react';
import { toPersianDigits } from '../../utils/persian';
const users = [{
  id: 1,
  name: 'علی احمدی',
  mobile: '09123456789',
  nationalId: '1234567890',
  status: 'verified',
  joinDate: '1402/01/15'
}, {
  id: 2,
  name: 'سارا محمدی',
  mobile: '09129876543',
  nationalId: '0987654321',
  status: 'pending',
  joinDate: '1402/02/20'
}, {
  id: 3,
  name: 'رضا کریمی',
  mobile: '09351234567',
  nationalId: '5678901234',
  status: 'verified',
  joinDate: '1402/03/10'
}, {
  id: 4,
  name: 'مریم حسینی',
  mobile: '09198765432',
  nationalId: '4321098765',
  status: 'rejected',
  joinDate: '1402/04/05'
}, {
  id: 5,
  name: 'محمد رضایی',
  mobile: '09121112233',
  nationalId: '1122334455',
  status: 'verified',
  joinDate: '1402/05/01'
}];
export function UsersPage() {
  return <AdminLayout data-id="element-225">
      <div className="space-y-6" data-id="element-226">
        <div className="flex justify-between items-center" data-id="element-227">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-228">مدیریت کاربران</h1>
          <Button data-id="element-229">افزودن کاربر جدید</Button>
        </div>

        <Card data-id="element-230">
          <CardHeader data-id="element-231">
            <div className="flex items-center gap-4" data-id="element-232">
              <div className="relative flex-1 max-w-sm" data-id="element-233">
                <Search className="absolute right-3 top-3 h-4 w-4 text-gray-400" data-id="element-234" />
                <Input placeholder="جستجو بر اساس نام، کد ملی..." className="pr-9" data-id="element-235" />
              </div>
            </div>
          </CardHeader>
          <CardContent data-id="element-236">
            <Table data-id="element-237">
              <TableHeader data-id="element-238">
                <TableRow data-id="element-239">
                  <TableHead data-id="element-240">نام و نام خانوادگی</TableHead>
                  <TableHead data-id="element-241">شماره موبایل</TableHead>
                  <TableHead data-id="element-242">کد ملی</TableHead>
                  <TableHead data-id="element-243">تاریخ عضویت</TableHead>
                  <TableHead data-id="element-244">وضعیت احراز هویت</TableHead>
                  <TableHead data-id="element-245">عملیات</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-246">
                {users.map(user => <TableRow key={user.id} data-id="element-247">
                    <TableCell className="font-medium" data-id="element-248">{user.name}</TableCell>
                    <TableCell data-id="element-249">{toPersianDigits(user.mobile)}</TableCell>
                    <TableCell data-id="element-250">{toPersianDigits(user.nationalId)}</TableCell>
                    <TableCell data-id="element-251">{toPersianDigits(user.joinDate)}</TableCell>
                    <TableCell data-id="element-252">
                      {user.status === 'verified' && <Badge variant="success" data-id="element-253">تایید شده</Badge>}
                      {user.status === 'pending' && <Badge variant="warning" data-id="element-254">در انتظار بررسی</Badge>}
                      {user.status === 'rejected' && <Badge variant="destructive" data-id="element-255">رد شده</Badge>}
                    </TableCell>
                    <TableCell data-id="element-256">
                      <Button variant="ghost" size="sm" data-id="element-257">
                        <MoreHorizontal className="h-4 w-4" data-id="element-258" />
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>;
}